/* eslint-disable */


/**
 * Create styles for `<Terms />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Terms />` styles
 */
const TermsStyles = ({ theme }) => ({
  terms: {
    '& li': {
      marginBottom: theme.spacing(1),
    },
    [`& a`]: {
      color: theme.palette.primary.main,
    },
    backgroundColor: theme.typography.body2.backgroundColor,
    color: theme.typography.body2.color,
    padding: theme.spacing(1) * 2,
  },
});

export default TermsStyles;
